import React from 'react';
import { string,func,object } from 'prop-types';
import style from './style';
import QuizSentenceBase from './QuizSentenceBase';
import BlankTooltip from '../Tooltip/BlankTooltip';


const QuizSentenceWithTooltip = ({content, blankColor, onClickBlank, options, onAssignBlank}) => {
	return <QuizSentenceBase 
		content = {content}
		renderBlank={({answer, index})=>{
			const optionsForAnswer = answer in options ? options[answer] : {};
			const {candidates=[],blankSize} = optionsForAnswer;
			const assignedIndex = onAssignBlank ? onAssignBlank(answer,index) : 0;
			return (
				<BlankTooltip
					key={answer+index}
					answer={answer}
					candidates={candidates}
				>
					<style.ClickableBlank 
						text={answer}
						blankSize={blankSize}
						annotation={`(${assignedIndex+1})` }
						blankColor={blankColor}
						onClick={(e)=>{onClickBlank && onClickBlank(assignedIndex,answer,e);}}
					/>
				</BlankTooltip>
			);
		}}
	/>;
};
QuizSentenceWithTooltip.propTypes = {
	content: string,
	blankColor : string,
	options : object,
	onClickBlank : func,
	onAssignBlank : func
};

export default QuizSentenceWithTooltip;